GatiServer = function () {
  this._stake = 0;
  this._bpl = 0;
  this._balance = 0;
  this._oldBalance = 0;
  this._preCommitBalance = 0;
  this._messageQueue = [];
  this._homeUrl = '';
  this._slotGame = null;
  this.totalGameWinnings = 0;
  this._numLines = 0;
  this._inGame = false;
  this._previousWagers = undefined;
  this._isPrePaidGame = false;
  this._loadingScreenData = {};
  this._finishedLoading = false;
  this._allowCheats = false;
  this._inRewatchMode = false;
  this._inReplayMode = false;
  this._restoringPreviousWager = false;
  this._allowAutoplay = true;
  this._allowGamble = false;
  this._allowUpstake = false;
  this._allowGameRules = true;
  this._hasHomeButton = true;
  this._gameNotFullyRecovered = false;
  this._latestEngineReponse = undefined;
  this._isRecoveryGame = false;
  this._didRecoveredGameSendFinish = false;
  this._wagerId = -1;
  this._assetTable = { table: {} };
  this._currentBetData = 0;
  this._coinValue = 10; // usual YG coin stuff
  this._translationsShared = '';
  this._translationsGame = '';
  this._clientState = {};
  this.canFullScreenBase = this.canFullScreen;
  this.canFullScreen = this.canFullScreenDerived;
  this._allowSplashScreen = true;
  this._muted = false;
  this._paused = false;

  this._platformAllowsFullScreen = false;
  this._pageShown = true;

  this._isSocial = false;

  messageBus.subscribe('game:previousStakeAndMode', this.onPreviousStakeAndMode.bind(this));
};

GatiServer.prototype.pausedBecauseOfReplay = function () {
  let res = false;
  if (this._paused === true && this._muted === true) {
    res = true;
  }
  return res;
};

GatiServer.prototype.canFullScreenDerived = function () {
  return this.canFullScreenBase() && !this.getDeviceInfo().ios && !this.getDeviceInfo().iPad;
};

GatiServer.prototype.getRegulatedMarket = function () {
  return '';
};
GatiServer.prototype.getPlatformLoadingData = function () {
  return this._loadingScreenData;
};

GatiServer.prototype.canFullScreen = function () {
  const res = this._platformAllowsFullScreen && !this._inRewatchMode && !this._inReplayMode; // YG draw an orange button over the game in these modes as a seperate div. If we go full screen when the player touches the splash screen our div goes over their div, so we can t do it;
  return res;
};

GatiServer.prototype.getEngineSupplier = function () {
  return 'gati';
};
GatiServer.prototype.getEngineVersion = function () {
  return '';
};
GatiServer.prototype.allowRCPopup = function (allow) {
  console.log('need to implement allowRCPopup');
};

GatiServer.prototype.changeStake = function (newStake, gameMode = 'default') {
  messageBus.post('platform:setGameStake', {
    newStake: newStake,
    gameMode: gameMode,
  });
  this._stake = newStake;
  this._slotGame.getGameEventsEmitter().totalBetChanged(this._stake / 100);
};

GatiServer.prototype.saveLanguageDataToFile = function () {
  if (gdk.isDevelopmentBuild()) {
    let self = this;
    async function saveFile() {
      // create a new handle
      const newHandle = await window.showSaveFilePicker();
      // create a FileSystemWritableFileStream to write to
      const writableStream = await newHandle.createWritable();

      let languageCode = gdk.getCurrentLanguage();
      let languageData = {
        shared: {},
        game: {},
      };

      languageData.shared[languageCode] = self._translationsShared;
      languageData.game[languageCode] = self._translationsGame;

      // write our file
      await writableStream.write(JSON.stringify(languageData));
      // close the file and write the contents to disk.
      await writableStream.close();
    }
    saveFile();
  }
};

GatiServer.prototype.subscribeEvents = function (slot) {
  var self = this;
  slot.subscribeOnEvents({
    skipSplashScreen: () => {
      gdk.loadingClosed();
      messageBus.post('game:skipSplash', {
        data: 'Platform skipped splash',
      });
    },
    skipVideoIntro: () => console.log('should skip video intro'),
    setMinBet: (bet) => {
      let sc = resourceManager.getController('stakeController');
      if (!sc.isMinStake()) {
        let allStakes = sc.Stakes;
        self.changeStake(allStakes[0]);
      }
    },
    initSpin: () => {
      if (this._finishedLoading && !this._inGame && gameController) {
        gameController.startGame();
      }
    },
    pauseGame: () => {
      this._paused = true;
      Reflex.gamePaused = true;
      messageBus.post('game:modal', {
        reason: 'Platform Paused',
        data: 'Platform Paused',
      });
      resourceManager.getController('inputOverlord').blockButtonPresses();
    },
    resumeGame: () => {
      this._paused = false;
      Reflex.gamePaused = false;
      messageBus.post('game:modal', { data: 'Platform Resume' });
    },
    updateGameBalance: (balance) => {
      self._balance = balance.cash * 100;
      self.addBalanceEventToQueue();
      // SRB - balance
      // if (!self._inGame && self._messageQueue.length === 0) {
      //   // if we are in a game cycle no need to update balance now, it will happen when needed. Otherwise update immediately
      //   self.addBalanceEventToQueue();
      //   self.triggerNextMessage();
      // }
    },
    popupOpened: () => {
      Reflex.gamePaused = true;
      messageBus.post('game:modal', {
        reason: 'Platform Error Popup',
        data: 'Platform Popup Open',
      });
    },
    popupClosed: () => {
      Reflex.gamePaused = false;
      messageBus.post('game:modal', { data: 'Platform Popup Close' });
    },
    errorPopupOpened: () => {
      Reflex.gamePaused = true;
      messageBus.post('game:modal', {
        reason: 'Platform Error Popup',
        data: 'Platform Error Popup Open',
      });
    },
    errorPopupClosed: () => {
      Reflex.gamePaused = false;
      messageBus.post('game:modal', { data: 'Platform Error Popup Close' });
    },
    getBalance: () => console.log('*DEPRECATED* should call currentBalance'),
    enableAudio: () => {
      const pausedBecauseOfReplay = this.pausedBecauseOfReplay();
      if (pausedBecauseOfReplay === true) {
        messageBus.post('game:backFromReplay', {});
      }
      this._muted = false;
      messageBus.post('audio:stateChanged', {
        type: 'audio:stateChanged',
        muted: false,
        from: 'platform',
      });
    },
    yggUIChanged: (margins) => {
      // currently only implemented to move screen down if there is a UI Element at the top of the screen
      if (margins.top > 0) {
        gdk.setPlatformScreenData({
          borderTop: margins.top,
          borderBottom: 0,
          borderLeft: 0,
          borderRight: 0,
        });
      } else {
        gdk.clearPlatformScreenData();
      }
    },
    uiChanged: (displayed) => {
      // currently only implemented to move screen down if there is a UI Element at the top of the screen
      // USE YGGUICHANGED INSTEAD
      /*	var found = false;
		var maxHeight = 0;
		for (var i = 0; i < displayed.length; ++i){
			found = true;
			if ((displayed[i].bounds.y === 0) && (displayed[i].bounds.height > maxHeight)){// only interested if y is 0 (anchored at the top)
				maxHeight = displayed[i].bounds.height;				
			}
		}
		if (found){
			gdk.setPlatformScreenData({
				borderTop:maxHeight,
				borderBottom:0,
				borderLeft:0,
				borderRight:0
			});
		}
		else {
			gdk.clearPlatformScreenData();
		}*/
    },
    disableAudio: () => {
      this._muted = true;
      const pausedBecauseOfReplay = this.pausedBecauseOfReplay();
      if (pausedBecauseOfReplay === true) {
        messageBus.post('game:goingToReplay', {});
      }
      messageBus.post('audio:stateChanged', {
        type: 'audio:stateChanged',
        muted: true,
        from: 'platform',
      });
    },
    getAudioVolume: () => console.log('should call audioVolume(volume) in pc.gameEventsEmitter()'),
    stopAutoSpin: () => {
      resourceManager.getController('autoplayController').cancel();
    },
    openGameRules: () => {
      htmlViewer.show(gdk.translateText('gameRules', []), 't_settings_close', true);
    },
    closeGameSession: () => {
      return !self._inGame && !autoplayManager.isAutoplayEnabled();
    },
  });

  messageBus.subscribe('common:RecoverGameListenerDead', function () {
    self._gameNotFullyRecovered = false; // allow state saving again
  });
};

GatiServer.prototype.initPlayerConnect = async function (
  provider,
  pcUrl,
  boostPosition,
  gameFeatures,
  replayBackPosition,
  callbackSuccess
) {
  await $.getScript(pcUrl || 'WRONG-PC-URL');
  //await $.getScript("https://dev.game.lan/pc/partnerconnect.js");
  let slot = new PartnerConnect.SlotGame();
  this.subscribeEvents(slot);
  let loadData = await slot.load({
    companyName: provider,
    boost: { buttonPosition: boostPosition },
    gameFeatures: gameFeatures,
    pcFeatures: {
      backButtonPosition: replayBackPosition,
      backButtonSettings: { opacity: 0.5 },
    },
  });
  this._license = loadData.customParameters.license;
  this._translationsShared = JSON.parse(JSON.stringify(loadData.translations.shared));
  this._translationsGame = JSON.parse(JSON.stringify(loadData.translations.game));
  this._translations = Object.assign(loadData.translations.shared, loadData.translations.game);
  this._allowAutoplay = !loadData.settings.isAutoSpinsDisabled;
  this._allowGamble = !loadData.settings.isGambleFeatureDisabled;
  this._allowUpstake = !loadData.settings.isGoldenBetDisabled;
  this._buyBonusAllowed = !loadData.settings.isBuyBonusDisabled;
  this._allowGameRules = loadData.settings.menuVisibility.isMenuRulesVisible;
  this._slotGame = slot;
  this._previousWagers = loadData.wagers;
  this._inRewatchMode = loadData.mode === 'REWATCH';
  this._inReplayMode = loadData.mode === 'REPLAY';
  this._inRestoreMode = loadData.mode === 'RESTORE';
  this._isSocial = loadData.settings.casinoType === 'SOCIAL';
  this._stake = loadData.settings.defaultBet * 100;
  this._allowSplashScreen = !loadData.settings.isSplashScreenDisabled;
  this.setDefaultBet(this._stake);
  gdk.setMinGameTime(loadData.settings.minimalSpinningTime);
  this.showPlatformOverlays(true);
  let self = this;
  this.getGameConfig(loadData, function () {
    self.loadAssetTable(callbackSuccess);
  });
};

GatiServer.prototype.isRewatchMode = function () {
  return this._inRewatchMode;
};

GatiServer.prototype.isReplayMode = function () {
  return this._inReplayMode;
};

GatiServer.prototype.loadAssetTable = function (cb) {
  let self = this;
  let filename = 'lookup_table_' + gameData.version + '.json';
  let webrequest = gdk.requestAsset(filename, function () {
    if (webrequest.status === 200) {
      self._assetTable = JSON.parse(webrequest.responseText);
      cb();
    }
  });

  webrequest.send(null);
};

GatiServer.prototype.init = function (
  callbackSuccess,
  callbackFailure,
  customer,
  boostPosition,
  gameFeatures,
  backButtonPosition
) {
  customer = customer || 'ReflexGaming';
  boostPosition = boostPosition || 'LEFT_BOTTOM'; //acceptable values are: LEFT_CENTER/LEFT_TOP/LEFT_BOTTOM/RIGHT_CENTER/RIGHT_TOP/RIGHT_BOTTOM/TOP_LEFT/TOP_CENTER/TOP_RIGHT/BOTTOM_LEFT/BOTTOM_CENTER/BOTTOM_RIGHT
  gameFeatures = gameFeatures || [];
  // https://doc-partnerconnect.yggdrasilgaming.com/dev/docs/enums/backbuttonposition.html
  backButtonPosition = backButtonPosition || 'TOP_LEFT'; //BOTTOM_LEFT, BOTTOM_RIGHT, TOP_LEFT, TOP_RIGHT

  let pcUrl;
  let lang;
  let currency;
  if (window._POST_PARAMS_) {
    pcUrl = window._POST_PARAMS_.pcUrl;
    lang = window._POST_PARAMS_.lang;
    currency = window._POST_PARAMS_.currency;
    this.replayFromIframeGame = window._POST_PARAMS_.replayFromIframeGame === 'yes';
  } else {
    var urlParams = {};
    var getParameterByName = function (url) {
      var match,
        pl = /\+/g, // Regex for replacing addition symbol with a space
        search = /([^&=]+)=?([^&]*)/g,
        decode = function (s) {
          return decodeURIComponent(s.replace(pl, ' '));
        },
        query = url.substring(1);

      urlParams = {};
      while ((match = search.exec(query))) urlParams[decode(match[1])] = decode(match[2]);
    };

    var url = window.location.href;
    url = url.substring(url.indexOf('?'), url.length);
    getParameterByName(url);
    currency = urlParams.currency;
    lang = urlParams.lang;
    pcUrl = urlParams.pcUrl;
    this.replayFromIframeGame = urlParams.replayFromIframeGame === 'yes';
  }

  this.initPlayerConnect(customer, pcUrl, boostPosition, gameFeatures, backButtonPosition, callbackSuccess);

  gdk.setCurrency(currency);
  if (lang === 'en') lang = 'en-GB';
  gdk.setAvailableLanguages([lang], lang);
};

GatiServer.prototype.loadingBegin = function () {
  const informLoadingBegun = async (slot) => {
    await slot.getGameEventsEmitter().gameLoadingStarted();
  };
  informLoadingBegun(this._slotGame);
};

GatiServer.prototype.loadingProgress = function (progress) {
  this._slotGame.getGameEventsEmitter().gameLoadingProgress(progress);
};

// showing "click to continue"
GatiServer.prototype.loadingComplete = function () {
  const informLoadingComplete = async (slot) => {
    await slot.getGameEventsEmitter().gameLoadingEnded();
  };
  informLoadingComplete(this._slotGame);
};

GatiServer.prototype.setDefaultBet = function (betAmount, gameMode = 'default') {
  this.changeStake(betAmount, gameMode);
};

GatiServer.prototype.restorePreviousGameModeData = function () {
  messageBus.postImmediate('restore:previousGameMode', {
    encore: this._inEncore,
    meta: this._meta,
  });
};

GatiServer.prototype.restorePreviousWagers = function () {
  let res = {
    baseStake: 0,
    stake: 0,
  };
  if (
    this._previousWagers &&
    this._previousWagers.data &&
    this._previousWagers.data.length > 0 &&
    this._previousWagers.data[0].bets &&
    this._previousWagers.data[0].bets.length > 0
  ) {
    // this function used to just look at the betamount, however it doesnt take into account
    // big bet (encore) or buy a bonus stakes. So we now set the base bet and let the recovery
    // resolve what the additional costs should be.
    let previousBet = Number(this._previousWagers.data[0].bets[0].betdata.coin);
    this._restoringPreviousWager = true;

    previousBet *= this._coinValue; // coin thing
    previousBet *= 100; // major to minor

    var stake = Number(this._previousWagers.data[0].bets[0].betamount) * 100 || previousBet;

    if (!this.isGameModeBonusBuy(this._previousWagers.data[0].bets[0].betdata.cmd)) {
      // buy a bonus isnt the default game bet, if it is a buy a bonus game dont change the default bet
      this.setDefaultBet(previousBet);
    } else {
      //We do this separately for bonus buy as golden bet uses the default game mode too and we dont want to risk breaking previous code
      this.setDefaultBet(previousBet, this._previousWagers.data[0].bets[0].betdata.cmd);
    }
    res.baseStake = previousBet;
    res.stake = stake;
    this.restorePreviousGameModeData();
  }
  return res;
};

GatiServer.prototype.checkForAndHandlePrepaids = function (prepaidObj) {
  if (prepaidObj && prepaidObj.amount) {
    this.changeStake(prepaidObj.amount * 100);
    messageBus.post('common:PromotionStarted');
    messageBus.post('platform:setButtonState', {
      buttonName: 'Stake',
      enabled: false,
    });

    this._isPrePaidGame = true;
  } else if (this._isPrePaidGame) {
    this._isPrePaidGame = false;
    messageBus.post('common:PromotionEnded', {
      replayGame: this._inRewatchMode || this._inReplayMode,
    });
    messageBus.post('platform:setButtonState', {
      buttonName: 'Stake',
      enabled: true,
    });
  }
};

GatiServer.prototype.clientReadyToStart = function (cbWhenPlatformReady) {
  var self = this;
  let stakeInfo = undefined;
  if (this._inRewatchMode || this._inReplayMode || this._inRestoreMode) {
    this._isPrePaidGame = true;
    stakeInfo = this.restorePreviousWagers();
    this._isPrePaidGame = false;
  }
  const informGameReady = async (slot) => {
    // yggs docs say we need to show, but Mario says not too so blame him :P
    const marioSaysNo = true;
    if (marioSaysNo === false && this._inReplayMode && this._isSocial === true) {
      await this.showReplayPopup();
    }

    var readyResponse = await slot.getGameEventsEmitter().gameReady({ defaultBetValue: this._stake / 100 });
    console.log('Gati Platform: Restore Mode set to ' + readyResponse.restoreMode);
    // no longer modal
    messageBus.post('game:modal', { data: 'Platform Ready To Start' });
    self._finishedLoading = true;
    self._isRecoveryGame = readyResponse.restoreMode === 'RESTORE';
    if (self._inRewatchMode || self._inReplayMode || self._isRecoveryGame) {
      this._restoringPreviousWager = false;
      gdk.startMinGameTimer(); // we bypass start during recovery so the gdk wont do this for us
      // self._isPrePaidGame = true; // Tells setBPL not to show max stake popup, this is a recover game they have already seen this popup
      // stakeInfo = self.restorePreviousWagers();
      self._isPrePaidGame = slot.getWagerHelper().getPrepaidInfo().isPrepaid; //prepaids has a very specifice purpose and this isnt it, so put it back!
      self.initNewGame({ stake: stakeInfo.stake, bpl: stakeInfo.baseStake / self._numLines }, self._isRecoveryGame);

      // now initGame no longer sends balance out because PokerStars doesnt want to the debit until
      // a result has been received so there are no errors, we must do it explicitly in side rewatch/recover/replay
      // SRB - balance
      // self.addBalanceEventToQueue();
      // self.triggerNextMessage();

      self._latestEngineReponse = { wager: this._previousWagers.data[0] };
      self._wagerId = self._latestEngineReponse.wager.wagerid;
      await this._slotGame.getGameEventsEmitter().gameRoundStarted();
      await this._slotGame.getGameEventsEmitter().spinStarted();
      self.addRecoveryToQueue();
      self.triggerNextMessage();
      cbWhenPlatformReady();
      messageBus.postImmediate('common:GameCommitted');
    } else if (readyResponse.restoreMode === 'SKIP') {
      // self.restorePreviousWagers();
      this._restoringPreviousWager = false;
      self._latestEngineReponse = { wager: this._previousWagers.data[0] };
      await self.handleSkipWin(self._latestEngineReponse);
      let win = await self.doCollectWinnings();
      gameData.winningsMeter.set(win);
      await self._slotGame.getGameEventsEmitter().gameRoundEnded();
      self._oldBalance = self._balance;
      self._preCommitBalance = self._balance;
      // SRB - balance
      // self.addBalanceEventToQueue();
      messageBus.postImmediate('common:GameSkipped', stakeInfo);
      self.checkForAndHandlePrepaids(readyResponse.nextPrepaid);
      // SRB - balance
      // self.triggerNextMessage();
      cbWhenPlatformReady();
    } else {
      self.checkForAndHandlePrepaids(readyResponse.nextPrepaid);

      if (!self._isPrePaidGame) {
        messageBus.postImmediate('game:previousStakeAndMode', {
          lastMode: persistence._lastMode,
          lastStake: persistence._lastStake,
        });
      }
      cbWhenPlatformReady();
    }
  };

  // stop game interaction just in case the recovery popup will show (we dont know until we have a response from gameReady)
  messageBus.post('game:modal', {
    reason: 'Waiting on Platform',
    data: 'Waiting on Platform',
  });

  informGameReady(this._slotGame);
};

GatiServer.prototype.onPreviousStakeAndMode = function (data) {
  if (typeof data.lastMode !== 'undefined' && typeof data.lastStake === 'number') {
    //0 = BASIC, 1 = LUCKYBET - 99% of the time
    if (data.lastMode === 0 || data.lastMode === 1) {
      this.changeStake(data.lastStake);
    }
  }
};

GatiServer.prototype.handleSkipWin = async function (lastEngineResponse) {
  // can be overriden by base class if it needs to perform skip actions. For example, tempered steel requires the nextCommand to be sent with the
  // pick me outcome so the engine can settle the round (hence why it is set to await too).
};

// tutorial clicked through
GatiServer.prototype.loadingClosed = function () {};

GatiServer.prototype.addTotalGameWinningsToQueue = function () {
  var message = {
    type: 'common:TotalGameWinnings',
    totalGameWinnings: this.totalGameWinnings,
  };
  this._messageQueue.push(message);
};

GatiServer.prototype.inIframe = function () {
  try {
    return window.self !== window.top;
  } catch (e) {
    return true;
  }
};

GatiServer.prototype.loadLanguageFiles = function (callback) {
  // strings from gati languages come without the escpare character \ and is read like "\\"
  for (var prop in this._translations) {
    if (this._translations.hasOwnProperty(prop)) {
      // originally used replaceAll but it has very sketchy support amongst browsers. Even polyfilling it caused issues
      while (this._translations[prop].indexOf('\\n') > 0) {
        this._translations[prop] = this._translations[prop].replace('\\n', '\n');
      }
    }
  }
  var translationsMap = {};
  translationsMap[gdk.getCurrentLanguage()] = this._translations;
  callback(translationsMap);
};

GatiServer.prototype.parseDenoms = function (denoms, denomValue) {
  var arrayStr = denoms;

  if (arrayStr[0] === 'NaN') {
    arrayStr = '[]';
  } else {
    arrayStr = '[' + arrayStr + ']';
  }

  var coinSizes = JSON.parse(arrayStr);
  return coinSizes.map(function (x) {
    return Number(x * 100 * denomValue).toFixed(0);
  });
};

GatiServer.prototype.parseDefaultBet = function (defaultDenom, denomValue) {
  var defaultStr = defaultDenom.substring(defaultDenom.indexOf(':') + 1, defaultDenom.length);
  return (parseFloat(defaultStr) * 100 * denomValue).toFixed(0);
};

GatiServer.prototype.isGameModeBonusBuy = function (mode) {
  return mode === 'BONUS_BUY';
};

GatiServer.prototype.parseGameModes = function (loadData, defaultNumLines) {
  let res = {};

  for (let mode in loadData.settings.modes) {
    if (loadData.settings.modes.hasOwnProperty(mode)) {
      if (this.isGameModeBonusBuy(mode) && !this._buyBonusAllowed) continue;
      let modeData = loadData.settings.modes[mode];
      let totalStakes = this.parseDenoms(modeData.coins, this._coinValue);
      res[mode] = {
        coinSizes: totalStakes.map(function (x) {
          return x / defaultNumLines;
        }),
        defaultAmountPerLine: this.parseDefaultBet(modeData.defaultCoin, this._coinValue) / defaultNumLines,
        coinsPerBet: modeData.coinsPerBet,
      };
    }
  }

  res.default = JSON.parse(JSON.stringify(res.BASIC));
  return res;
};

GatiServer.prototype.addGameConfigToQueue = function (loadData) {
  this._hasHomeButton = loadData.settings.menuVisibility.isMenuHomeVisible;

  var message = {};
  message['type'] = 'spinner:GameConfigEvent';
  message.preloaderMessage = '';
  message.showGamCare = false;
  message.minLoadingTime = 0;
  message.showHomeButton = this._hasHomeButton;
  message.homeURL = this._homeUrl;
  message.slotConfig = loadData.settings.slotConfig.Config['spinner:GameConfigEvent'].slotConfig;
  message.mathsVersion = loadData.settings.slotConfig.Config['spinner:GameConfigEvent'].mathsVersion;
  message.reelSets = loadData.settings.slotConfig.Config['spinner:GameConfigEvent'].reelSets;
  message.slotConfig.prizeTable.sort(function (firstEl, secondEl) {
    if (firstEl.id < secondEl.id) {
      return -1;
    } else if (firstEl.id > secondEl.id) {
      return 1;
    } else {
      if (firstEl.count < secondEl.count) return -1;
      if (firstEl.count > secondEl.count) return 1;
      return 0;
    }
  });
  message.autoplay = loadData.settings.slotConfig.Config['spinner:GameConfigEvent'].autoplay;
  message.mathsVersion = loadData.settings.slotConfig.Config['spinner:GameConfigEvent'].mathsVersion;
  message.autoplay.numberOfRounds = {
    defaultIndex: 0,
  };

  let autplayLevels = loadData.settings.autoplayLevels;
  if (autplayLevels) {
    message.autoplay.numberOfRounds.values = autplayLevels;
    if (autplayLevels[autplayLevels.length - 1] === Infinity) {
      message.autoplay.numberOfRounds.values.pop();
    }
  }

  // no "no limit" allowed in loss limit
  if (message.autoplay && message.autoplay.lossLimit && message.autoplay.lossLimit.values.length > 0) {
    var index = message.autoplay.lossLimit.values.indexOf(-1);
    if (index >= 0) {
      // we need to remove no limit
      // this may affect the default index into the loss limit, so store current default limit
      var currentDefaultLimit = message.autoplay.lossLimit.values[message.autoplay.lossLimit.defaultIndex];
      // remove no limit
      message.autoplay.lossLimit.values.splice(index, 1);
      // reset the default index back to the value it should be
      message.autoplay.lossLimit.defaultIndex = message.autoplay.lossLimit.values.indexOf(currentDefaultLimit);
      // if we have removed the default value (should be no limit in this case) then set it to 0
      if (message.autoplay.lossLimit.defaultIndex === -1) message.autoplay.lossLimit.defaultIndex = 0;
    }
  }

  message.slotConfig.defaultNumLines = 1;

  if (message.slotConfig.paylines)
    // might be always pays game
    message.slotConfig.defaultNumLines = message.slotConfig.paylines.length;
  let gameModes = this.parseGameModes(loadData, message.slotConfig.defaultNumLines);
  message.slotConfig.gameModes = gameModes;

  message.slotConfig.defaultAmountPerLine = gameModes.default.defaultAmountPerLine; // backlwards compatibility, ideally we sould be using the gameModes object
  message.slotConfig.coinSizes = gameModes.default.coinSizes; // backwards compatibility, ideally we sould be using the gameModes object

  message.slotConfig.RTP = [];

  for (var i = 0; i < message.slotConfig.coinSizes.length; ++i) {
    message.slotConfig.RTP.push(message.slotConfig.rtp);
  }

  this._numLines = message.slotConfig.defaultNumLines;
  this._allowCheats = this.getAllowCheatOptions(loadData);

  this._platformAllowsFullScreen = loadData.settings.menuVisibility.isMenuFullScreenVisible;

  var showFullscreenBtn =
    this._platformAllowsFullScreen && !this.inIframe() && !this.getDeviceInfo().iPad && !this.getDeviceInfo().ios; // cant go full screen if in an iFrame. Confirmed this behaviour with Kamil at Yggdrasil

  message.uiElements = {
    btnRules: {
      enabled: loadData.settings.menuVisibility.isMenuRulesVisible,
      visible: loadData.settings.menuVisibility.isMenuRulesVisible,
    },
    btnHome: message.showHomeButton,
    btnFullscreen: { enabled: showFullscreenBtn, visible: showFullscreenBtn },
    btnHistory: {
      enabled: loadData.settings.menuVisibility.isGameHistoryVisible,
      visible: loadData.settings.menuVisibility.isGameHistoryVisible,
    },
    btnTurboMode: { enabled: false, visible: false },
    cbHistory: this.showHistory.bind(this),
    uiClock: loadData.settings.clockVisibility,
    btnInfo: {
      enabled: loadData.settings.menuVisibility.isMenuPaytableVisible,
      visible: loadData.settings.menuVisibility.isMenuPaytableVisible,
    },
    btnAutoplay: {
      enabled: !loadData.settings.isAutoSpinsDisabled,
      visible: !loadData.settings.isAutoSpinsDisabled,
    },
    btnSkip: {
      enabled: loadData.customParameters.disableSkip !== 'yes',
      visible: true,
    },
    btnSettings: {
      enabled:
        loadData.settings.menuVisibility.isMenuAudioVisible && loadData.settings.menuVisibility.isMenuSettingsVisible,
      visible:
        loadData.settings.menuVisibility.isMenuAudioVisible && loadData.settings.menuVisibility.isMenuSettingsVisible,
    },
    btnSound: {
      enabled: loadData.settings.menuVisibility.isMenuAudioVisible,
      visible: loadData.settings.menuVisibility.isMenuAudioVisible,
    },
    btnGamble: { enabled: this._allowGamble, visible: this._allowGamble },
    btnUpstake: { enabled: this._allowUpstake, visible: this._allowUpstake },
  };

  message.slotConfig.allowSlamStop =
    loadData.settings.minimalSpinningTime <= 0 && loadData.customParameters.disableSkip !== 'yes';

  // dont enable settings menu even if platform says it is ok if we dont have anything to show
  var settingsMenuOptions = 0;
  settingsMenuOptions += message.uiElements.btnFullscreen.enabled ? 1 : 0;
  settingsMenuOptions += message.uiElements.btnHistory.enabled ? 1 : 0;
  settingsMenuOptions += message.uiElements.btnTurboMode.enabled ? 1 : 0;
  settingsMenuOptions += message.uiElements.btnSound.enabled ? 1 : 0;
  settingsMenuOptions += message.uiElements.btnRules.enabled ? 1 : 0;
  message.uiElements.btnSettings.enabled &= settingsMenuOptions > 0;

  this.initialisePersistence(loadData, message);

  this._messageQueue.push(message);
};

GatiServer.prototype.mustShowSlowWin = function () {
  return this._license === 'it'; // crap, should reall be an explicit setting on PartnerConnect
};

GatiServer.prototype.getAllowCheatOptions = function () {
  // https://jira.yggdrasilgaming.com/browse/EMRFGM1MNT-27
  return false; // this function gets overridden by debug_index.html as per YG integration report. If debug_index.html is not loaded it should be impossible to get cheats
};

GatiServer.prototype.isAutoplayAllowed = function () {
  return this._allowAutoplay;
};

GatiServer.prototype.isGambleAllowed = function () {
  return this._allowGamble;
};

GatiServer.prototype.isBuyBonusAllowed = function () {
  return this._buyBonusAllowed;
};

GatiServer.prototype.isUpstakeAllowed = function () {
  return this._allowUpstake;
};

GatiServer.prototype.getAllowSplashScreen = function () {
  return this._allowSplashScreen;
};

GatiServer.prototype.addShowEventToQueue = function (reelList) {
  var message = {
    type: 'spinner:ShowEvent',
    mainContext: {
      lastPanel: {
        reelList: reelList,
      },
    },
  };
  this._messageQueue.push(message);
};

GatiServer.prototype.addAvailableActionsToQueue = function () {
  var message = {
    type: 'spinner:AvailableActionsEvent',
    availableActions: ['SPIN'],
  };
  this._messageQueue.push(message);
};

GatiServer.prototype.addBalanceEventToQueue = function () {
  var message = {
    type: 'common:BalanceEvent',
    balance: this._inRewatchMode ? 0 : this._balance,
  };
  messageBus.postImmediate(message.type, { data: message });
  // this._messageQueue.push(message);
};

GatiServer.prototype.addGameCompleteToQueue = function (totalWon) {
  var message = {
    type: 'common:GameCompleteEvent',
    totalWinnings: totalWon,
  };
  this._messageQueue.push(message);
};

GatiServer.prototype.addNetworkErrorToQueue = function (inReason, hideHeaders, showCloseButton) {
  var showHeaders = true;
  if (hideHeaders !== undefined) {
    showHeaders = !hideHeaders;
  }
  var message = {
    type: 'common:NetworkError',
    reason: inReason,
    closeButton: showCloseButton,
    showHeaders: showHeaders,
  };
  this._messageQueue.push(message);
};

GatiServer.prototype.sendNetworkError = function (reason, hideHeaders, showCloseButton) {
  console.log(reason);
  this.addNetworkErrorToQueue(reason, hideHeaders, showCloseButton);
  this.triggerNextMessage();
};
GatiServer.prototype.clearMessageQueue = function () {
  this._messageQueue = [];
};
GatiServer.prototype.addMessageToQueue = function (message) {
  this._messageQueue.push(message);
};
GatiServer.prototype.abortingGame = function (reason) {
  this.allowRCPopup(true);
};

GatiServer.prototype.isGameWhiteBox = function () {
  return false;
};

GatiServer.prototype.hasForceOptions = function () {
  return this._allowCheats;
};

GatiServer.prototype.hasReplayForce = function () {
  return false;
};

GatiServer.prototype.sendResponseError = function (data) {
  if (data) {
    this.sendNetworkError('Could not parse server response: ' + data);
  } else {
    this.sendNetworkError('Could not parse server response');
  }
};

GatiServer.prototype.addRecoveryToQueue = function () {
  let commandsSent = [];

  clientParams = this._previousWagers.data[0].bets[0].betdata.clientParams;

  for (let i = 0; i < this._previousWagers.data[0].bets.length; ++i) {
    if (this._previousWagers.data[0].bets[i].betdata) {
      commandsSent.push(this._previousWagers.data[0].bets[i].betdata.cmd);
    }
  }

  let lastEventData = this._previousWagers.data[0].bets[this._previousWagers.data[0].bets.length - 1].eventdata;
  if (lastEventData && lastEventData.nextCmds && lastEventData.nextCmds === 'C') {
    this._didRecoveredGameSendFinish = true;
  } else {
    this._didRecoveredGameSendFinish = false;
  }

  messageBus.post('game:modal', {
    reason: 'Recovery Popup',
    data: 'Recovery Popup',
  });
  var message = {
    type: 'common:RecoverGame',
    bpl: this._bpl,
    gameState: this._gameState,
    recoverFromStart: true,
    clientParams: clientParams,
    previousCommands: commandsSent,
    replay: this._inReplayMode,
    rewatch: this._inRewatchMode,
  };
  if (this._meta) {
    message.metaData = this._meta.name;
    message.metaValue = this._meta.value;
  }

  this._messageQueue.push(message);

  // this task gets held on to by features that need to recover player selection, they leave it when
  // they have finished inputting recovered selection. This way the Dead is only sent when everything has recovered
  // this is so we dont allow the sending of client state back to the engine if the new recovery didnt get as far through
  // as previous recovery.
  var message2 = {
    type: 'common:RecoverGameListener',
    bpl: this._bpl,
    gameState: this._gameState,
    recoverFromStart: true,
    clientParams: clientParams,
    previousCommands: commandsSent,
    replay: this._inReplayMode,
  };
  if (this._meta) {
    message2.metaData = this._meta.name;
    message2.metaValue = this._meta.value;
  }

  this._gameNotFullyRecovered = true;

  // dont add it to the message queue as we dont want to block messages whilst this task is being hung on to
  messageBus.taskImmediate(message2.type, message2);
};

GatiServer.prototype.gameLoaded = function () {
  this.triggerNextMessage();
};

GatiServer.prototype.getGameConfig = function (loadData, cb) {
  if (loadData.settings.preloader && loadData.settings.preloader.hasMessage) {
    this._loadingScreenData.minLoadingTime = loadData.settings.preloader.delay;
    this._loadingScreenData.message = loadData.settings.preloader.message;
    this._loadingScreenData.gamCareLogo = true;
  }

  this._balance = loadData.settings.balance * 100;
  this._maxWins = loadData.settings.slotConfig.Config['spinner:GameConfigEvent'].slotConfig.maxWins;
  this._coinSizes = loadData.settings.slotConfig.Config['spinner:GameConfigEvent'].slotConfig.coinSizes;
  this.addGameConfigToQueue(loadData);
  this.addShowEventToQueue([]);
  this.addAvailableActionsToQueue();
  this._oldBalance = this._balance;
  this._preCommitBalance = this._balance;
  // SRB - balance
  // this.addBalanceEventToQueue();
  cb();
};

GatiServer.prototype.peekNextMessage = function () {
  if (this._messageQueue.length === 0) return undefined;

  return this._messageQueue[0];
};

GatiServer.prototype.triggerNextMessage = function () {
  if (this._messageQueue.length === 0) return;

  var message = this._messageQueue[0];
  this._messageQueue.splice(0, 1);
  gdk.handleServerMessage(message);
};

GatiServer.prototype.messageHandled = function () {
  this.triggerNextMessage();
};

GatiServer.prototype.setBPL = function (bpl) {
  var newStake = this._numLines * bpl;
  if (this._stake != newStake) {
    this._stake = newStake;
    this._slotGame.getGameEventsEmitter().totalBetChanged(this._stake / 100);
  }
};

GatiServer.prototype.playerChangedStake = function (currentStake) {
  this._slotGame.getGameEventsEmitter().totalBetChanged(currentStake / 100);
};

GatiServer.prototype.initNewGame = function (stakeData, recoveryGame) {
  this.totalGameWinnings = 0;
  this._currentBetData = 0;
  this._stake = stakeData.stake;
  this._bpl = this._stake / stakeData.numWinlines;
  if (stakeData.bpl) {
    this._bpl = stakeData.bpl;
  }
  this._preCommitBalance = this._balance;
  if (!this._isPrePaidGame && !recoveryGame) {
    this._balance -= this._stake;
  }

  this._oldBalance = this._balance;
  if (this._balance < 0) {
    // gonna fail the spin
    this._oldBalance = this._preCommitBalance; // put old balance back to what the balance will be once spin fails
    this._balance = 0; // Gati wants you to be able to start a game even if you dont have enough credit
  }
  // poker stars dont want balance to disappear until game is committed
  // https://jira.yggdrasilgaming.com/browse/EMRFGM1MNT-129
  // SRB - balance - already commented out
  //	this.addBalanceEventToQueue();
  //	this.triggerNextMessage();
  this.allowRCPopup(false);
  this._inGame = true;
};

GatiServer.prototype.startGame = function (stakeData, cb) {
  this.initNewGame(stakeData, false);
  return this.doStartGame(stakeData, cb);
};

GatiServer.prototype.doStartGame = async function (stakeData, cb) {
  var self = this;
  let stakeInMajor = stakeData.stake / 100;
  await this._slotGame.getGameEventsEmitter().gameRoundStarted();

  let spinData = {
    amount: stakeInMajor,
    coin: stakeInMajor / this._coinValue,
    coins: this._coinValue,
  };

  if (this._forces) {
    this.addCheatToRequest(spinData, this._forces);
  }

  this.addMetaDataToSpinRequest(spinData);

  this._latestEngineReponse = undefined;
  let gameAborting = false;
  this._latestEngineReponse = await this._slotGame
    .spin(spinData)
    .catch(function () {
      gameAborting = true;
      self._balance = self._preCommitBalance;
      gdk.abortGame();
      messageBus.post('game:modal', {
        reason: 'Game Aborted',
        data: 'Game Aborted',
      });
    })
    .finally(function () {
      if (gameAborting) {
        messageBus.post('game:modal', { data: 'Game Aborted Complete' });
      }
    });

  if (this._latestEngineReponse) {
    // protection in case spin was aborted
    // poker stars dont want balance to disappear until game is committed
    // https://jira.yggdrasilgaming.com/browse/EMRFGM1MNT-129
    // SRB - balance
    // this.addBalanceEventToQueue();
    // this.triggerNextMessage();

    this._wagerId = this._latestEngineReponse.wager.wagerid;
    await this._slotGame.getGameEventsEmitter().spinStarted();
    this._forces = this.updateForces(this._forces);
    if (this.allowDebugLogging()) {
      console.log('Result: ' + JSON.stringify(this._latestEngineReponse.wager.bets[0].eventdata.response.clientData));
    }
    cb();
  }
};

GatiServer.prototype.addMetaDataToSpinRequest = function (request) {};

GatiServer.prototype.addCheatToRequest = function (request, forces) {
  let forcesJson = JSON.parse(forces);

  if (!forcesJson || forcesJson.length === 0) return;

  // games with player choice like gambles have cheats as part of a multidemential array
  let isMultiCheat = forcesJson[0].constructor === Array;
  if (isMultiCheat) {
    // next cheat is first index from list
    let nextCheatStr = JSON.stringify(forcesJson[0]);
    request.cheat = nextCheatStr;
  } else {
    request.cheat = forces;
  }
};

GatiServer.prototype.updateForces = function (forces) {
  if (!forces) return undefined;
  let forcesJson = JSON.parse(forces);

  if (!forcesJson || forcesJson.length === 0) return;

  // games with player choice like gambles have cheats as part of a multidemential array
  let isMultiCheat = forcesJson[0].constructor === Array;

  if (isMultiCheat) {
    // remove processed cheat
    forcesJson.shift();

    // reset the variable coming in to the next cheat along
    if (forcesJson.length > 0) {
      return JSON.stringify(forcesJson);
    }
  }
  return undefined;
};

GatiServer.prototype.endGame = function (cb) {
  this.doEndGame(cb);
};

GatiServer.prototype.doFinaliseGamecycle = async function () {
  await this._slotGame.getGameEventsEmitter().spinEnded();

  if (this._inRewatchMode || this._inReplayMode) return; // dont call play during rewatch/replay

  let nextStep = this._latestEngineReponse.wager.bets[this._latestEngineReponse.wager.bets.length - 1].step + 1;
  this._latestEngineReponse = await this._slotGame.play({
    cmd: 'Finished',
    step: nextStep,
    clientParams: JSON.stringify({
      finishedByPlayer: true,
    }),
  });
};

GatiServer.prototype.doCollectWinnings = async function () {
  let res = 0;
  let nextStep = this._latestEngineReponse.wager.bets[this._latestEngineReponse.wager.bets.length - 1].step + 1;
  if (this._latestEngineReponse.wager && this._latestEngineReponse.wager.status === 'Pending') {
    // player won?
    this._latestEngineReponse = await this._slotGame.collect({
      step: nextStep,
    });
    const win = this._latestEngineReponse.wager.bets.reduce((result, bet) => {
      return result + parseFloat(bet.wonamount);
    }, 0);
    res = win;
  }
  return res * 100;
};

GatiServer.prototype.doEndGame = async function (cb) {
  this._clientState = {};
  if (!this._isRecoveryGame || (this._isRecoveryGame && !this._didRecoveredGameSendFinish)) {
    // if the game crashed after we sent the finished api call (very unlikely) then when we recover it we cannot send the finished call again, otherwise we have to
    await this.doFinaliseGamecycle();
  }
  this.totalGameWinnings = await this.doCollectWinnings();

  let gameRoundEndResponse = await this._slotGame.getGameEventsEmitter().gameRoundEnded();
  this._inGame = false;

  this._oldBalance = this._balance;
  this._preCommitBalance = this._balance;
  this._didRecoveredGameSendFinish = false;
  this._isRecoveryGame = false;
  this.addTotalGameWinningsToQueue();
  this.allowRCPopup(true);
  this.addAvailableActionsToQueue();
  // SRB - balance
  // this.addBalanceEventToQueue();
  // we need to send the triggerNextMessage, as this will send the total game winnings
  // which gdk listens for and updates the autoplay last session data with
  // another reason to hate these message queues
  this.triggerNextMessage();
  this.totalGameWinnings = 0;
  this._latestEngineReponse = undefined;
  this._gameNotFullyRecovered = false;
  this.checkForAndHandlePrepaids(gameRoundEndResponse.nextPrepaid);
  if (!this._inRewatchMode && !this._inReplayMode) {
    cb(); // rewatch mode shouldn't enable the buttons to continue playing, so dont inform the client of a successful endGame, just leave it blocked
  } else {
    messageBus.post('platform:ReplayComplete');
  }
};

GatiServer.prototype.validateResponse = function (data) {
  if (!data) {
    this.sendNetworkError('Invalid response');
    return false;
  }
  return true;
};

GatiServer.prototype.allowDebugLogging = function () {
  return !this.isProductionBuild();
};

GatiServer.prototype.isProductionBuild = function () {
  return false;
};

GatiServer.prototype.resetCurrentBetData = function () {
  this._currentBetData = 0;
};

// used by games with recovery and multiple commands to server (like gambling, see dublin up)
GatiServer.prototype.moveToNextBetData = function () {
  ++this._currentBetData;
};

GatiServer.prototype.getCheatString = function () {
  if (this._latestEngineReponse.wager.bets[this._currentBetData].eventdata.cheat) {
    let jsObj = JSON.parse(
      '[2244615896,2244615896,' + this._latestEngineReponse.wager.bets[this._currentBetData].eventdata.cheat + ']'
    );
    let negativeIdx = jsObj.indexOf(-1);
    while (negativeIdx !== -1) {
      jsObj.splice(negativeIdx, 1);
      negativeIdx = jsObj.indexOf(-1);
    }
    return JSON.stringify(jsObj);
  }
  return '';
};

GatiServer.prototype.logCheatString = function () {
  if (this._latestEngineReponse.wager.bets[this._currentBetData].eventdata.cheat) {
    let force = this.getCheatString();
    console.log('Force: ' + JSON.stringify(force));
  }
};

GatiServer.prototype.requestNextSpinOutcome = function (cb) {
  this.logCheatString();
  let outcome = this._latestEngineReponse.wager.bets[this._currentBetData].eventdata.response.clientData;
  let playerState = this._latestEngineReponse.wager.bets[this._currentBetData].eventdata.playerState;
  let initialPlayerState = this._latestEngineReponse.wager.bets[this._currentBetData].eventdata.playerState;
  this.getSpinData(cb, outcome, playerState, initialPlayerState);
};

GatiServer.prototype.reduceWinlineWins = function (spinEvent, winningsEvent, deltaCash) {
  spinEvent.totalWinnings = deltaCash;
  winningsEvent.totalLineWinnings = deltaCash;
  for (var i = 0; i < winningsEvent.winningLines.length; ++i) {
    winningsEvent.winningLines[i].winAmount = Math.min(winningsEvent.winningLines[i].winAmount, deltaCash);
    deltaCash -= winningsEvent.winningLines[i].winAmount;
    if (deltaCash <= 0 && winningsEvent.winningLines.length > i + 1) {
      winningsEvent.winningLines.splice(i + 1, winningsEvent.winningLines.length - i);
    }
  }
};

GatiServer.prototype.getNextGameOutcome = function (cb) {
  this.requestNextSpinOutcome(cb);
};

GatiServer.prototype.allowSpinIfNotEnoughCredit = function () {
  return true;
};

GatiServer.prototype.saveClientState = function (data, cb) {
  this._clientState = data;
  if (this._gameNotFullyRecovered || this._inRewatchMode || this._inReplayMode || this._didRecoveredGameSendFinish) {
    // dont record client state if we are still recovering otherwise we will overwrite previous further recovery data
    cb();
    return;
  }

  let self = this;
  const doStateSave = async () => {
    let nextStep = self._latestEngineReponse.wager.bets[self._latestEngineReponse.wager.bets.length - 1].step + 1;
    self._latestEngineReponse = await self._slotGame.play({
      cmd: 'Checkpoint',
      step: nextStep,
      clientParams: JSON.stringify(data),
    });
    cb();
  };
  doStateSave();
};

GatiServer.prototype.getSavedClientState = function () {
  return this._clientState;
};

GatiServer.prototype.updateAndSaveClientState = function (propertyName, propertyValue, cb) {
  this._clientState[propertyName] = propertyValue;
  this.saveClientState(this._clientState, cb);
};

GatiServer.prototype.addSpinDataToQueue = function (event) {
  var message = {};
  message.type = 'spinner:SpinEvent';

  message.panelMultiplier = 1;
  message.lines = event.lines;
  message.baseBet = this._stake;
  message.betMultiplier = 1;
  message.totalWinnings = event.totalWinnings;
  message.resultPanel = {};
  message.resultPanel.reels = 5;
  message.resultPanel.rectangular = true;
  if (event.jackpotGame !== undefined && event.jackpotGame === true) {
    message.jackpotGame = true;
  }

  message.resultPanel.reelList = event.resultsPanel.reelList;
  message.resultPanel.symbolsAbove = event.resultsPanel.symbolsAbove;
  message.resultPanel.symbolsBelow = event.resultsPanel.symbolsBelow;

  this._messageQueue.push(message);
};

GatiServer.prototype.addWinningsToQueue = function (event) {
  var message = event;
  message.type = 'spinner:WinningLinesEvent';
  this._messageQueue.push(message);
};

GatiServer.prototype.onFullscreenChange = function (callback) {
  $(document).on(
    'fullscreenchange mozfullscreenchange webkitfullscreenchange msfullscreenchange fullscreenerror',
    function () {
      callback();
    }
  );

  $(document).on('fullscreenerror', function () {
    callback();
  });
};

GatiServer.prototype.isFullscreen = function () {
  return (
    typeof (
      document.fullscreenElement ||
      document.mozFullScreenElement ||
      document.webkitFullscreenElement ||
      document.msFullscreenElement
    ) !== 'undefined'
  );
};

GatiServer.prototype.getScreenWidth = function () {
  return window.innerWidth;
};

GatiServer.prototype.getScreenHeight = function () {
  return window.innerHeight;
};

GatiServer.prototype.getWindowSize = function () {
  var size = {};

  if (systemData.isFullScreen) {
    let devInfo = this.getDeviceInfo();
    if ((devInfo.android && devInfo.osMajorVersion <= 4) || (devInfo.mobile && devInfo.firefox) || devInfo.safari) {
      size.width = this.getScreenWidth();
      size.height = this.getScreenHeight();
    } else {
      size.width = screen.width;
      size.height = screen.height;
    }
  } else {
    size.width = this.getScreenWidth();
    size.height = this.getScreenHeight();
  }

  return size;
};

GatiServer.prototype.onWindowResize = function (callback) {
  window.addEventListener('resize', callback);
};
GatiServer.prototype.onKeydown = function (callback) {
  window.addEventListener('keydown', callback);
};
GatiServer.prototype.onKeyup = function (callback) {
  window.addEventListener('keyup', callback);
};
GatiServer.prototype.onFocus = function (callback) {
  window.addEventListener('focus', callback);
};
GatiServer.prototype.onBlur = function (callback) {
  window.addEventListener('blur', callback);
};

GatiServer.prototype.onVisibilityChange = function (callback) {
  let windowHidden = null;
  let windowVisibilityChange = null;
  let windowVisibilityState = null;

  if (typeof document.hidden !== 'undefined') {
    windowHidden = 'hidden';
    windowVisibilityChange = 'visibilitychange';
    windowVisibilityState = 'visibilityState';
  } else if (typeof document.msHidden !== 'undefined') {
    windowHidden = 'msHidden';
    windowVisibilityChange = 'msvisibilitychange';
    windowVisibilityState = 'msVisibilityState';
  } else if (typeof document.webkitHidden !== 'undefined') {
    windowHidden = 'webkitHidden';
    windowVisibilityChange = 'webkitvisibilitychange';
    windowVisibilityState = 'webkitVisibilityState';
  } else if (typeof document.mozHidden !== 'undefined') {
    windowHidden = 'mozHidden';
    windowVisibilityChange = 'mozvisibilitychange';
    windowVisibilityState = 'mozVisibilityState';
  }

  document.addEventListener(windowVisibilityChange, () => {
    if (document[windowVisibilityState] === 'hidden') {
      this._pageShown = false;
    } else {
      this._pageShown = true;
    }
    callback(this._pageShown);
  });
};

GatiServer.prototype.isPageShown = function () {
  return this._pageShown;
};

GatiServer.prototype.gameForces = function (json) {
  this._forces = json;
};

GatiServer.prototype.requestFullscreen = function () {
  if (this._inRewatchMode || this._inReplayMode) return; // YG draw an orange button over the game in these modes as a seperate div. If we go full screen when the player touches the splash screen our div goes over their div, so we can t do it
  if (!this.canFullScreenDerived()) return;

  if (document.documentElement.requestFullscreen) {
    document.documentElement.requestFullscreen();
  } else if (document.documentElement.mozRequestFullScreen) {
    document.documentElement.mozRequestFullScreen();
  } else if (document.documentElement.webkitRequestFullscreen) {
    document.documentElement.webkitRequestFullscreen();
  } else if (document.documentElement.msRequestFullscreen) {
    document.documentElement.msRequestFullscreen();
  }
};
GatiServer.prototype.exitFullscreen = function () {
  if (document.exitFullscreen) {
    document.exitFullscreen();
  } else if (document.webkitExitFullscreen) {
    document.webkitExitFullscreen();
  } else if (document.mozCancelFullScreen) {
    document.mozCancelFullScreen();
  } else if (document.msExitFullscreen) {
    document.msExitFullscreen();
  }
};

GatiServer.prototype.canAutoplayContinue = function () {
  return true;
};
GatiServer.prototype.canStartAutoplayGame = function (callback) {
  return true;
};
GatiServer.prototype.isPromotionActive = function (callback) {
  return this._isPrePaidGame;
};
GatiServer.prototype.isPromotionChargeable = function (callback) {
  return false;
};
GatiServer.prototype.isiPad = function () {
  return (
    navigator.userAgent.match(/iPad/i) != null || (navigator.userAgent.includes('Mac') && 'ontouchend' in document)
  );
};
GatiServer.prototype.isMobile = function () {
  return bowser.mobile === true || this.isiPad() || bowser.android ? true : false;
};
GatiServer.prototype.getDeviceInfo = function () {
  var self = this;
  return {
    msie: bowser.msie,
    mobile: self.isMobile(),
    android: bowser.android,
    osVersion: bowser.osVersion,
    name: bowser.name,
    safari: bowser.safari,
    chrome: bowser.chrome,
    version: bowser.version,
    firefox: bowser.firefox,
    devicePixelRatio: window.devicePixelRatio,
    iPad: self.isiPad(),
    ios: bowser.ios,
  };
};
GatiServer.prototype.goHome = function () {
  this._slotGame.uiComponents().clickActionHandler().home();
};

GatiServer.prototype.showHistory = function () {
  this._slotGame.uiComponents().showGameHistory();
};

GatiServer.prototype.showReplayPopup = async function () {
  this._slotGame.uiComponents().showReplaySummary('replaySummary');
  let resolver = null;
  const promise = new Promise((resolve) => {
    resolver = resolve;
  });

  const popup = document.getElementById('replaySummary');
  function handleTouch() {
    resolver();
    popup.removeEventListener('pointerdown', handleTouch);
  }
  // need to add a touch listener to know when to remove
  popup.addEventListener('pointerdown', handleTouch);

  await promise;

  this._slotGame.uiComponents().removeReplaySummary();
};

GatiServer.prototype.hasHomeButton = function () {
  return this._hasHomeButton;
};

GatiServer.prototype.formatCurrency = function (value, currency, currencySymbols = true) {
  const formatter = PartnerConnect.PreparedObjectsFactory.getCurrencyFormatter();
  let result = '';

  if (this._inRewatchMode || !currencySymbols) {
    result = formatter.formatDecimal(value / 100);
  } else {
    result = formatter.formatWithCurrency(value / 100);
  }

  return result;
};

GatiServer.prototype.showPlatformOverlays = function (show) {
  this._slotGame.setGameCanvasCovered(!show);
};

GatiServer.prototype.ammendResourceName = function (resourceName) {
  if (this._assetTable.table.hasOwnProperty(resourceName)) return this._assetTable.table[resourceName];
  return resourceName;
};

GatiServer.prototype.isGameRulesAllowed = function () {
  return this._allowGameRules;
};

GatiServer.prototype.chosenAutoplayData = function (totalSpins, limitLoss, limitWin, totalBet) {};
GatiServer.prototype.helpPageShowingPaytable = function () {};
GatiServer.prototype.helpPageVisible = function () {};
GatiServer.prototype.stakePopupVisible = function () {};

GatiServer.prototype.buildPersistenceInitialisationData = function (loadData, gameConfigMessage) {
  const data = {
    enabled: false,
    dataPath: '',
    defaultData: loadData.settings.slotConfig.Config['spinner:GameConfigEvent'].slotConfig.defaultFeatureState,
    modes: gameConfigMessage.slotConfig.gameModes,
    currentMode: this.currentMode ? this.currentMode : 'BASIC',
    numWinLines: gameConfigMessage.slotConfig.defaultNumLines,
    current: this.getCurrentPlayerStateFromLoadData(loadData),
    modeMapping: {
      default: 'BASIC',
    },
  };

  // we can inherit, call the base to get the data object
  // add our own dataPath
  // we need to do this as the config hasnt been loaded yet!!!!!!
  // const data = GatiServer.prototype.buildPersistenceData.call(this, loadData, true);
  // data.dataPath = 'featureState.features';
  // data.enabled = true;   // lib defaults to off

  return data;
};

GatiServer.prototype.getCurrentPlayerStateFromLoadData = function (loadData) {
  const playerState =
    loadData.mode === 'RESTORE' || loadData.mode === 'REPLAY' || loadData.mode === 'REWATCH'
      ? loadData.wagers.data[0].bets[0].eventdata.response.clientData.InitialGameState
      : loadData.settings.gameFeatures?.playerState?.playerState;
  return playerState;
};

GatiServer.prototype.initialisePersistence = function (loadData, gameConfigMessage) {
  const data = this.buildPersistenceInitialisationData(loadData, gameConfigMessage);
  persistence.initialise(data);
};

GatiServer.prototype.isSocial = function () {
  return this._isSocial;
};
